export const Props = () => ({
  //Цена
  price: {
    type: String,
    required: false,
  },

  //Значение в теге
  value: {
    type: String,
    required: false,
  },

  //Валюта
  currency: {
    type: String,
    required: false,
  },

  //Это PON подписка?
  isPon: {
    type: Boolean,
  },

  //Кол-во дней
  days: {
    type: Number,
    required: false,
  },

  //Тег значение
  tag: {
    type: String,
    required: false,
  },

  //Tег стиль
  tagStyle: {
    type: String,
    required: false,
  },

  //Активен ли элемент?
  isActive: {
    type: Boolean,
    required: false,
  },

  //Кол-во подарочных кодов активации
  giftsCount: {
    type: Number,
    required: false,
  }
});
